import { render, staticRenderFns } from "./TestimSlider.vue?vue&type=template&id=c23cb932&scoped=true&"
import script from "./TestimSlider.vue?vue&type=script&lang=js&"
export * from "./TestimSlider.vue?vue&type=script&lang=js&"
import style0 from "./TestimSlider.vue?vue&type=style&index=0&id=c23cb932&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23cb932",
  null
  
)

export default component.exports